// extracted by mini-css-extract-plugin
export default {"remove_object_container":"RemoveObject_remove_object_container__KUM8D","confirm_remove":"RemoveObject_confirm_remove__84h1B","text":"RemoveObject_text__OMaNI"};